module.exports = __webpack_public_path__ + "static/media/29ADMSPC19.5300df69.jpg";